import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostDeactivateTimefencePayload, PostDeactivateTimefenceResponse } from '@/api/timefence/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postDeactivateTimefence = (
    payload: PostDeactivateTimefencePayload
): Promise<PostDeactivateTimefenceResponse> => {
    return axios.post('/device/deactivate-timefence', payload);
};

type UsePostDeactivateTimefenceOptions = {
    config?: MutationConfig<typeof postDeactivateTimefence>;
    data?: PostDeactivateTimefencePayload;
};

export const usePostDeactivateTimefence = ({ config }: UsePostDeactivateTimefenceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postDeactivateTimefence,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Timefence deactivated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('deactivate timefence'),
    });
};
